enum ContactTypes {
    CONTACT_LOADED = 'CONTACT_LOADED',
    CONTACT_UPDATED = 'CONTACT_UPDATED',
    CUSTOMER_UPDATED = 'CUSTOMER_UPDATED',
    CLEAR_CONTACT = 'CLEAR_CONTACT',
    SET_CONTACT = 'SET_CONTACT',
    UPDATE_DPA_RESULT = 'UPDATE_DPA_RESULT',
    UPDATE_AGENT_DPA = 'UPDATE_AGENT_DPA',
    UPDATE_DPA = 'UPDATE_DPA',
    UPDATE_CONTACT_ATTRIBUTES = 'UPDATE_CONTACT_ATTRIBUTES',
    REMOVE_CONTACT_ATTRIBUTES = 'REMOVE_CONTACT_ATTRIBUTES',
    UPDATE_CONTACT = 'UPDATE_CONTACT',
    GET_CONTACT = 'GET_CONTACT',
    PARK_CALL_CONTACT = 'PARK_CALL_CONTACT',
    UPDATE_ACW_ATTRIBUTES = 'UPDATE_ACW_ATTRIBUTES',
}

export default ContactTypes;
